import { WimTransit } from 'store/wim/types';
import { AxlesType } from '../ArchiveTabs/components/VehicleSchema';

export const getVehicleSchema = (transit: WimTransit) => {
  const axles: AxlesType[] = transit.axles.map(({ wheelbase, tires, weight, number, overweight, weightLimit }) => {
    const axleGroupIndex = transit.axlesGroups.findIndex(
      ({ firstAxle, lastAxle }) => firstAxle <= number && lastAxle >= number
    );

    const result = {
      axleDistance: wheelbase,
      dualWheels: tires === 2,
      weight,
      weightLimit,
      overload: overweight,
    };

    if (axleGroupIndex >= 0) {
      return {
        ...result,
        group: {
          overload: transit.axlesGroups[axleGroupIndex].overweight,
          groupIndex: axleGroupIndex,
          weightLimit: transit.axlesGroups[axleGroupIndex].totalWeightLimit,
        },
      };
    }

    return result;
  });

  const violations = { overWidth: false, overHeight: false, overLength: false };
  if (transit.size) {
    transit.size.length.oversize > 0 && (violations.overLength = true);
    transit.size.height.oversize > 0 && (violations.overHeight = true);
    transit.size.width.oversize > 0 && (violations.overWidth = true);
  }
  const totalWeightLimitValue = transit.measurmentLimits?.find((v) => v.type === 'WEIGHT_LIMIT')?.value;
  const totalWeightLimit = totalWeightLimitValue || 0;
  return {
    axles,
    width: transit.size.width.value,
    widthLimit: transit.size.width.limit,
    height: transit.size.height.value,
    heightLimit: transit.size.height.limit,
    length: transit.size.length.value,
    lengthLimit: transit.size.length.limit,
    totalWeight: transit.weight,
    totalWeightLimit,
    overweightPercent: transit.overweightPercent,
    ...violations,
  };
};
